<template>
  <div>
    <collapse v-if="isDataLoaded">
      <collapse-item body-classes="p-0 m-0">
        <template slot="title">
          <h3 class="mb-0">
            <span>Resumen por Cultivo</span>
          </h3>
        </template>

        <div>
          <el-table :data="summaryByCrop" header-row-class-name="thead-light">
            <el-table-column label="Cultivo" min-width="120px" prop="varietyName">
              <template #default="{ row }">
                <span class="ml-2">{{ row.crop }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Recibidas" min-width="120px" prop="entries">
              <template #default="{ row }">
                <span class="ml-2">{{ row.entries }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Ajustes" min-width="120px" prop="adjusts">
              <template #default="{ row }">
                <span class="ml-2">{{ row.adjusts }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Pedidos" min-width="120px" prop="totalOrders">
              <template #default="{ row }">
                <span class="ml-2">{{ row.totalOrders }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Transf." min-width="120px" prop="transfers">
              <template #default="{ row }">
                <span class="ml-2">{{ row.transfers }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Dev. C. Central" min-width="120px" prop="devolutions">
              <template #default="{ row }">
                <span class="ml-2">{{ row.devolutions }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Stock" min-width="120px" prop="totalStock">
              <template #default="{ row }">
                <span class="ml-2">{{ row.totalStock }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </collapse-item>
    </collapse>

    <collapse v-if="isDataLoaded">
      <collapse-item body-classes="p-0 m-0">
        <template slot="title">
          <h3 class="mb-0">
            <span>Resumen por Variedad</span>
          </h3>
        </template>

        <div>
          <el-table :data="summaryByVariety" header-row-class-name="thead-light">
            <el-table-column label="Variedad" min-width="120px" prop="varietyName">
              <template #default="{ row }">
                <span class="ml-2">{{ row.variety }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Recibidas" min-width="120px" prop="entries">
              <template #default="{ row }">
                <span class="ml-2">{{ row.entries }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Ajustes" min-width="120px" prop="adjusts">
              <template #default="{ row }">
                <span class="ml-2">{{ row.adjusts }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Pedidos" min-width="120px" prop="totalOrders">
              <template #default="{ row }">
                <span class="ml-2">{{ row.totalOrders }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Transf." min-width="120px" prop="transfers">
              <template #default="{ row }">
                <span class="ml-2">{{ row.transfers }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Dev. C. Central" min-width="120px" prop="devolutions">
              <template #default="{ row }">
                <span class="ml-2">{{ row.devolutions }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Stock" min-width="120px" prop="totalStock">
              <template #default="{ row }">
                <span class="ml-2">{{ row.totalStock }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </collapse-item>
    </collapse>

    <card body-classes="p-0" footer-classes="pb-2">
      <template slot="header">
        <h3 class="mb-0">Stocks articulos</h3>
      </template>

      <div class="col-12 my-4 d-flex justify-content-end flex-wrap">
        <base-input label="Asesor Técnico" class="mr-2">
          <el-select v-model="sellerSelected" placeholder="Seleccione Asesor Técnico">
            <el-option label="TODOS" :value="null" class="select-primary"></el-option>
            <el-option v-for="item in sellers" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </base-input>

        <base-input label="Variedad">
          <el-select v-model="varietySelected" placeholder="Seleccione Variedad">
            <el-option label="TODOS" :value="null" class="select-primary"></el-option>
            <el-option
              v-for="item in varieties"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              class="select-primary"
            >
            </el-option>
          </el-select>
        </base-input>
      </div>

      <div v-if="isDataLoaded" class="table-responsive">
        <el-table :data="stockData" header-row-class-name="thead-light" :row-class-name="getRowClass">
          <el-table-column label="Cod" min-width="100px" prop="code">
            <template #default="{ row }">
              <span>{{ row.code }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Variedad" min-width="130px" prop="variety">
            <template #default="{ row }">
              <span>{{ row.variety }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Articulo" min-width="150px" prop="article">
            <template #default="{ row }">
              <span>{{ row.article }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Distribuidor" min-width="160px" prop="distributor">
            <template #default="{ row }">
              <router-link
                :to="{
                  name: 'StockByDistributor',
                  params: { distributor: row.distributorId, campaign: row.campaignId },
                }"
                class="link-primary"
              >
                {{ row.distributor }}
              </router-link>
            </template>
          </el-table-column>

          <el-table-column label="Ases. Tecnico" min-width="160px" prop="seller">
            <template #default="{ row }">
              <div>{{ row.seller }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Recibidas" min-width="130px" prop="entries">
            <template #default="{ row }">
              <div>{{ row.entries }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Ajustes" min-width="120px" prop="adjusts">
            <template #default="{ row }">
              <div>{{ row.adjusts }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Pedidos" min-width="120px" prop="totalOrders">
            <template #default="{ row }">
              <div>{{ row.totalOrders }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Transf." min-width="120px" prop="transfers">
            <template #default="{ row }">
              <div>{{ row.transfers }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Dev.C.Central" min-width="120px" prop="devolutions">
            <template #default="{ row }">
              <div>{{ row.devolutions }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Stock" min-width="120px" prop="totalStock">
            <template #default="{ row }">
              <div>{{ row.totalStock }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div
        v-if="!isDataLoaded"
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div>
          <p class="card-category">Cargando stocks...</p>
        </div>
      </div>

      <div
        v-else-if="isDataLoaded && !stockData.length"
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div>
          <p class="card-category">No hay datos para mostrar.</p>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';
import '@/assets/css/styles.css';

let lastVariety;
let lastCode;
let whiteColor = true;
let classRow;

export default {
  name: 'StockByArticles',
  components: {
    Collapse,
    CollapseItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    campaignId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      stockData: [],
      isDataLoaded: false,
      varieties: [],
      summaryByVariety: [],
      summaryByCrop: [],
      sellers: [],
      varietySelected: null,
      sellerSelected: null,
    };
  },

  watch: {
    varietySelected(value) {
      this.$emit('varietyChange', value);
      this.fetchTableData();
    },

    sellerSelected(value) {
      this.$emit('sellerChange', value);
      this.fetchTableData();
    },
  },

  mounted() {
    this.fetchTableData();
    this.fetchVarieties();
    this.fetchSellers();
    this.fetchsummaryByVariety();
    this.fetchsummaryByCrop();
  },

  methods: {
    fetchTableData() {
      this.$services
        .resource('stocks')
        .byArticle(this.campaignId, this.varietySelected, this.sellerSelected)
        .then((res) => {
          this.stockData = res.data;
          this.isDataLoaded = true;
        });
    },

    fetchVarieties() {
      const params = {
        'filter[campaign]': this.campaignId,
      };
      this.$services
        .resource('varieties')
        .get(params)
        .then((res) => {
          this.varieties = res.data.data.varieties;
        });
    },

    fetchSellers() {
      this.$services
        .resource('sellers')
        .get()
        .then((res) => {
          this.sellers = res.data.data.sellers;
        });
    },

    fetchsummaryByCrop() {
      this.$services
        .resource('stocks')
        .cropsTotals(this.campaignId, this.varietySelected, this.sellerSelected)
        .then((res) => (this.summaryByCrop = res.data));
    },

    fetchsummaryByVariety() {
      this.$services
        .resource('stocks')
        .varietiesTotals(this.campaignId, this.varietySelected, this.sellerSelected)
        .then((res) => (this.summaryByVariety = res.data));
    },

    getRowClass({ row }) {
      if (lastVariety !== row.variety) {
        lastVariety = row.variety;
        classRow = whiteColor ? 'classRowBackgroundColorWhite' : 'classRowBackgroundColorCake';
        whiteColor = !whiteColor;
      }
      const index = this.stockData.findIndex((item) => item.code == row.code);
      if (lastCode !== row.code && index !== 0) {
        lastCode = row.code;
        return classRow + ' topLineTd';
      }
      return classRow;
    },
  },
};
</script>
